import { render } from "./hiddenHotspot.vue?vue&type=template&id=0b90dd28"
import script from "./hiddenHotspot.vue?vue&type=script&lang=js"
export * from "./hiddenHotspot.vue?vue&type=script&lang=js"

import "./hiddenHotspot.vue?vue&type=style&index=0&id=0b90dd28&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__